module.exports = __webpack_public_path__ + "static/media/design-develop-second@3x.517639cb.jpg";